import React from "react";
import SettingsForm from "../components/settings";
export function SettingsPage() {
  return (
    <div>
      <SettingsForm />
    </div>
  );
}
export default SettingsPage;
